import { render, staticRenderFns } from "./Icono.html?vue&type=template&id=191de7e0&scoped=true&"
import script from "./Icono.vue?vue&type=script&lang=js&"
export * from "./Icono.vue?vue&type=script&lang=js&"
import style0 from "./Icono.scss?vue&type=style&index=0&id=191de7e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191de7e0",
  null
  
)

export default component.exports